import { AccountInfo, AuthenticationResult, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../auth/msalConfig';

export interface AuthUser {
  account: AccountInfo;
  isAuthenticated: boolean;
}

export class AuthService {
  private msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  async login(): Promise<void> {
    try {
      await this.msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login redirect failed:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      await this.msalInstance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
    } catch (error) {
      console.error('Logout redirect failed:', error);
      throw error;
    }
  }

  async getAccessToken(account: AccountInfo): Promise<string | null> {
    try {
      const silentRequest = {
        ...loginRequest,
        account,
      };

      const response: AuthenticationResult =
        await this.msalInstance.acquireTokenSilent(silentRequest);
      return response.accessToken;
    } catch (error) {
      console.error('Silent token acquisition failed:', error);
      try {
        await this.msalInstance.acquireTokenRedirect(loginRequest);
        return null;
      } catch (interactiveError) {
        console.error('Interactive token acquisition failed:', interactiveError);
        return null;
      }
    }
  }

  getCurrentUser(): AccountInfo | null {
    const accounts = this.msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }

  isAuthenticated(): boolean {
    return this.msalInstance.getAllAccounts().length > 0;
  }

  getAllAccounts(): AccountInfo[] {
    return this.msalInstance.getAllAccounts();
  }
}
